import styled from '@emotion/styled';
import UnstyledErrorIcon from '@material-ui/icons/Error';
import COLORS from '$variables/colors';
import { spacing, breakpoints } from '$variables/theme';

export const State = styled.div`
  color: ${COLORS.shadow5};
  cursor: pointer;
  padding: ${spacing.xSmall} ${spacing.small};

  @media (min-width: ${breakpoints.mediumStart}) {
    padding: 0 ${spacing.small};
  }
`;

export const ErrorIcon = styled(UnstyledErrorIcon)`
  color: ${COLORS.errorRed};
  width: 16px;
  height: 16px;
  margin-right: ${spacing.xxSmall};
`;

export const ErrorState = styled.div`
  display: flex;
  align-items: center;
`;
